import {plural} from '../../common/components/Plural.js'
import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {
  transferListQuerySelector,
  countSelector,
} from './transferListFunctions.js'
import {useSelector} from '../../store.js'

export default function TransferListItemsCount() {
  const params = useSelector(transferListQuerySelector)
  const count = useSelector(countSelector)

  return (
    <li className="inline-block margin-right-3">
      <ListItemsCount
        limit={params.limit}
        offset={params.offset}
        count={count}
        thing={plural(count)`Transfer${['s']}`}
      />
    </li>
  )
}
